import * as React from "react";

export const NotFoundScreen = (props: { entityName: string }) => (
  <div className="flex-fill d-flex flex-column justify-content-center align-items-center">
    <h1>Ops! {props.entityName} not found...</h1>
  </div>
);
